const styles = (theme) => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    width: '100%',
    padding: '32px',
    backgroundColor: theme.palette.primary.white,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: theme.textWhite.main,
    borderRadius: '8px',
    overflow: 'hidden',
  },
  settings: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    maxWidth: '900px',
    width: '100%',
    padding: '24px',
    boxSizing: 'border-box',
  },
});

export default styles;
